 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		80: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"pages/content/amlpolicy/pages/content/game-rules/pages/content/intellectual-property/pages/content/l/9f3ea104","27":"pages/cashbox/deposit/pages/cashbox/withdrawal","28":"pages/profile/pages/profile/bonuses/index","41":"header-c","42":"lang-ru.js","43":"lang-ua.js","44":"pages/auth/_social/cb","45":"pages/cashbox/deposit","46":"pages/cashbox/history","47":"pages/cashbox/index","48":"pages/cashbox/payin-error","49":"pages/cashbox/payin-status-ext","50":"pages/cashbox/payin-success","51":"pages/cashbox/payout-error","52":"pages/cashbox/payout-success","53":"pages/cashbox/support","54":"pages/cashbox/withdrawal","55":"pages/content/amlpolicy","56":"pages/content/faq","57":"pages/content/game-rules","58":"pages/content/intellectual-property","59":"pages/content/license","60":"pages/content/partners","61":"pages/content/privacy-policy","62":"pages/content/responsible-gaming","63":"pages/content/rules","64":"pages/error-game","65":"pages/game/_term","66":"pages/index","67":"pages/lobby/_section","68":"pages/lobby/_section/_sub-section","69":"pages/profile","70":"pages/profile/bonuses/index","71":"pages/profile/kycaid","72":"pages/profile/settings/index","73":"pages/profile/support-faq/index","74":"pages/promotions/_term","75":"pages/promotions/index","76":"pages/promotions/loyalty_system_promo_page/index","77":"pages/promotions/welcome-pack/index","78":"pages/registration","79":"pages/verifications/index","82":"vendors/pages/lobby/_section"}[chunkId]||chunkId) + "." + {"0":"f28d96ca609580683fcf","1":"d20f0d567c3fe89953dc","2":"3b5ff821d8316cd6bf11","3":"c3d255da41b945dbc20d","4":"360565591a58e22c6387","5":"0b1d102bc641ab66aef1","6":"66cc22a808fd83b89b4b","7":"7395e369341b30ea99fe","8":"b688d0196221a905f245","9":"a90f51e2ba8ae0d2b825","10":"6ba2c80dc2b52fdf3491","11":"8c5cf9c5f2ef6324c9af","12":"a88d364ed352b3109c00","13":"39d3abf275969e00bc03","14":"7268d346169a8c5b4ff6","15":"f453f06f945ebff28e74","16":"1553d55203346dde2f1b","17":"7a9ff86d7b53d66aac7a","18":"a03aea277d492429ebd0","19":"238da450eae20d84aa9c","20":"dc75c020edd10c907028","21":"3534eb4a15b36a343a6f","22":"05fb471ee903f0aea0b6","23":"184cb6b38f9e08a15960","24":"0db305a76d0fdabf8f71","25":"b39ec6f5ba041224d3e4","26":"6c81829dcbb08f6aebfc","27":"d62910efdcf0bf2a6751","28":"23fc7294edb2f9054151","29":"52141ccbc5a0a2dd5786","30":"a200cd95a7514bd319d2","31":"5f5bb01d70d37eb32b9b","32":"85ef1382c4b3c8f1f6e6","33":"9f046d030abc7e2ab55c","34":"495cd69d48be76a39f03","35":"db49c251b5605b71d74f","36":"e53fca8fbc8d4c749f09","37":"fd21774af5d086fb1e4c","38":"8c214c5b945bf4550ac8","41":"38a3ca81562641be16c4","42":"0fa09e0d08ecbb6b4ea9","43":"8cb8908b22c911ddc07d","44":"4ff3251aabb618e6cca6","45":"b0ed66a0d24cf2965675","46":"dfe1648071ff20673a88","47":"3b5db5bd4df7204b3284","48":"7aaecc03cc09ebdc778b","49":"8bd660002236ebe8b978","50":"b9e582917364318adeae","51":"abd8120fe8ef15f09e98","52":"82c87485ad9b76e45b01","53":"4d03615bad05883b2b44","54":"0697bc29ca26b949f6d5","55":"c648398e7591b398279a","56":"f04a4ff08f951f533b3b","57":"6a127f98af0cb3141882","58":"d8444c9b373e8730f4e3","59":"e0c519426b91fd804c06","60":"34da97c59fd79b7ce1bf","61":"c37c260e10ce7535f205","62":"b788642a5c8454697519","63":"e11a787c8a6756aa6ac2","64":"86cd33dac2ffe6b294d8","65":"967c0b96a0429eb0f781","66":"4eb160d0452196efbfe7","67":"fd7307d65897c3f9506f","68":"31e0c0b497b2b23f0445","69":"00fb40502d3223513ee3","70":"1ef72486c538f1a439a9","71":"8d877357f1ff53c536fc","72":"f9a368dbeefd1b23619f","73":"a740f56351aa2ff9999b","74":"db9309043adac9d48720","75":"8144e5656a0a2f33dfbb","76":"df7235598ab237b50fdc","77":"5a9f82c31d8ab48ce2a8","78":"64f9809e501aefff01de","79":"14d80493d10654f41d3f","82":"8e0784599589102d01d7","83":"1f62c787ecf2b86caa5b","84":"0d7ca3e2819aa958d5d8","85":"7c906b59187ad2f1f3b5","86":"0f828d0340d87162b055","87":"b4a6af65479f2e3a9581","88":"2c2fae2fdb93535c040c","89":"587cd567810e6f52cd04","90":"a92778819515d22fbf5c","91":"4fbd13c093a2a6d9004d","92":"21033a9df30b99f9e82c","93":"4c28d68666818c9dbfba","94":"4f34289f8bc05745fab4","95":"6b6a85baaff1b133ba2c","96":"92cf3dc396d78db62af0","97":"7f920cff0091c4b6fde5","98":"359c453bd4dd853831f7","99":"45feb234bceeb5932587","100":"c60bef977527f1d8519b","101":"ca92a8b4845b4702567f","102":"d9d404ca732c58796c84","103":"18a91e42510c9adfe0dd","104":"16b485541d440ec33127","105":"810df382813641209133","106":"55b33165042d86dfede5","107":"b291131a3ed5c32c9b12","108":"35a285d22c4ede400615","109":"f9203402c465c83e6c64","110":"a4c8285c6795413a3d7f","111":"5ada6a5e27dbc2795b6f","112":"14f50c9b8e0797749813","113":"7064ee98044581ef29e6","114":"74a50fc248e58bee2af9","115":"8e738ea1f8412dbc28d1","116":"4726b17dc154b1a123f6","117":"eb4c965d6a5d69725e3f","118":"2621816fc9199dcd4b06","119":"1efec7590934bc078b22","120":"fa899e277746bde67a30","121":"8f061ec7288a16bf2019","122":"5ffd0e58f7e0fb20fb30","123":"65b8afec531d414d3fbe","124":"d119f6faf8ac13c17782","125":"af16c150e71e484c7954","126":"c18ccbe50d5968e7bdfd","127":"5e1652e0feade6475ac7","128":"6a713e0dc4e5e26947e0","129":"26e30567fbe38f55a660","130":"7e6da47deff92c08d30f","131":"954bbe16703addd0301c","132":"c70364f4ea8db1b4089d","133":"300b0a0fd76ef87a4304","134":"768522cc291c2bc06d34","135":"53648541d5a62a22600c","136":"d5c895a4a8cf77d65fb0","137":"9e3cb29f01a73549762e","138":"476abadc86dcbd38b00b","139":"d80225b4397d02a50804","140":"80a7f8e0e2acfbb99ef6","141":"a87ea5ae5db6afba8d4d","142":"aa6d012c0cf6dd404c1d","143":"1c84ad10e1cca68ec622","144":"3118b5225bc704e85b40","145":"cdb328fb238e8c73cfd5","146":"7ebd8af5fd7c292062e8","147":"2a95a7dbe2a4dba1cd47","148":"710650c75261be949eaa","149":"99f3768f600c19ed33c9","150":"f3c62865fc566cd6cadd"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/_static/build/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
